/**
 * @generated SignedSource<<26e60c505d2015591aced3fd9d771c6b>>
 * @relayHash 290f48b556e12b5a1334003810acff7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c75522ed1e3129192ab93a435441931fb6dc43b088ee75fcffa32771fff22a09

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type viewAgent_agentDetailsQuery$variables = {
  agentAri: string;
  agentId: string;
  cloudId: string;
  cloudIdString: string;
  enableJiraAgentFields: boolean;
  enableStudioGSNAndScenarioRefresh: boolean;
  first?: number | null;
  hasActivationId: boolean;
  product: string;
  workspaceId?: string | null;
};
export type viewAgent_agentDetailsQuery$data = {
  readonly agentStudio_agentById?: {
    readonly __typename: string;
    readonly message?: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_agentRef">;
  } | null;
  readonly agentStudio_scenarioListByContainerId: {
    readonly __typename: "AgentStudioScenariosResult";
    readonly " $fragmentSpreads": FragmentRefs<"viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_scenarioListRef">;
  } | null;
  readonly atlassianStudio_userSiteContext: {
    readonly userPermissions?: {
      readonly " $fragmentSpreads": FragmentRefs<"viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_userPermissionsRef">;
    } | null;
  } | null;
};
export type viewAgent_agentDetailsQuery = {
  response: viewAgent_agentDetailsQuery$data;
  variables: viewAgent_agentDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableJiraAgentFields"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableStudioGSNAndScenarioRefresh"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasActivationId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "product"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v14 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudIdString"
  },
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "agentId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v15 = [
  (v12/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "viewAgent_agentDetailsQuery",
    "selections": [
      {
        "condition": "hasActivationId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "args": [
                  (v12/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "enableJiraAgentFields",
                    "variableName": "enableJiraAgentFields"
                  },
                  {
                    "kind": "Variable",
                    "name": "enableStudioGSNAndScenarioRefresh",
                    "variableName": "enableStudioGSNAndScenarioRefresh"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_agentRef"
              },
              (v13/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v14/*: any*/),
        "concreteType": "AgentStudioScenariosResult",
        "kind": "LinkedField",
        "name": "agentStudio_scenarioListByContainerId",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_scenarioListRef"
          }
        ]
      },
      {
        "args": (v15/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_userPermissionsRef"
                  }
                ]
              }
            ],
            "type": "AtlassianStudioUserSiteContextOutput"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "viewAgent_agentDetailsQuery",
    "selections": [
      {
        "condition": "hasActivationId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "enableJiraAgentFields",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "AgentStudioAgentPermissions",
                        "kind": "LinkedField",
                        "name": "permissions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canEdit"
                          }
                        ]
                      },
                      {
                        "args": (v15/*: any*/),
                        "concreteType": "JiraAgentAssignability",
                        "kind": "LinkedField",
                        "name": "jiraAssignability",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isAssignable"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "enableStudioGSNAndScenarioRefresh",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "instructions"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "agentSchemaNumber"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "creatorType"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "accountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                          }
                        ],
                        "type": "AtlassianAccountUser"
                      },
                      (v16/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      },
                      (v16/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVerified"
                  },
                  (v16/*: any*/)
                ],
                "type": "AgentStudioAssistant"
              },
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v16/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "args": (v14/*: any*/),
        "concreteType": "AgentStudioScenariosResult",
        "kind": "LinkedField",
        "name": "agentStudio_scenarioListByContainerId",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "concreteType": "AgentStudioScenariosEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isWebSearchEnabledForScenarioAndOrganization"
                  },
                  (v16/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isAgentStudioScenario"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isWebSearchEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isWebSearchEnabledForOrganization"
                      }
                    ],
                    "type": "AgentStudioBaseConfiguration",
                    "abstractKey": "__isAgentStudioBaseConfiguration"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v15/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAbleToGovernAgents"
                  }
                ]
              }
            ],
            "type": "AtlassianStudioUserSiteContextOutput"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c75522ed1e3129192ab93a435441931fb6dc43b088ee75fcffa32771fff22a09",
    "metadata": {},
    "name": "viewAgent_agentDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c0808ddd77edcdef9202dd091cdd279a";

export default node;
